<template>
    <div style="width: 150px;">
        <span class="font-size-btns">
            <template v-for="(size, i) in sizes">
                <b-button :key="`fontsize_${i}`" @click="$emit('save', size)">{{size}}</b-button>
            </template>
        </span>
        <b-input-group>
            <b-input v-model="customSize" placeholder="12"></b-input>
            <template #append>
                <b-button @click="$emit('save', customSize)">
                    <font-awesome-icon :icon="['fas', 'angle-right']" />
                </b-button>
            </template>
        </b-input-group>
    </div>
</template>

<script>
export default {
    name: "FontSizePicker",
    data: () => ({
        customSize: null,
    }),
    computed: {
        sizes: () => [
            12, 18, 24, 30, 36, 48, 60, 72, 96
        ],
    }
}
</script>

<style scoped>
.font-size-btns button {
    width: 50px;
    height: 40px;
}
button {
    border-radius: 0;
}
</style>